
import { Component, Prop, Vue } from 'vue-property-decorator'
import { clientsModule, commonModule } from '@/store/modules/store-accessor'
import dayjs from 'dayjs'
import { formatAmount, isDecimalNumber } from '@/helpers/data'

@Component
export default class RecordPrepaymentModal extends Vue {
  @Prop() payload!: any
  loading = false
  createdAtDateMenu = false
  createdAtTimeMenu = false

  prepaymentModel: Record<string, any> = {
    amount: null,
    payment_type_id: this.paymentTypesCombo[0],
    notes: '',
    created_at_date: dayjs().format('YYYY-MM-DD'),
    created_at_time: dayjs().format('HH:mm'),
  }

  paymentTypeRule = [
    (val: any) => (val || "").id > 0 || this.$i18n.t("payment_type_required"),
  ];

  notesRules = [
    (val: any) => {
      if (val != null)
        return val.length <= 1000 || this.$i18n.t("form_notes_length_rule");
      else return true;
    }
  ];

  amountRules = [
    (val: any) => {
      if (val === "" || isNaN(val)) {
        return this.$i18n.t("nonZeroAmountRuleText");
      }
      return Math.round(Number(val) * 100) > 0 || this.$i18n.t("nonZeroAmountRuleText");
    },
  ];

  get paymentTypesCombo() {
    return commonModule.paymentTypeCombo;
  }

  get disableSubmit() {
    return !this.prepaymentModel.amount || !this.prepaymentModel.payment_type_id || this.prepaymentModel?.notes?.length > 1000;
  }

  async mounted() {
    await commonModule.getPaymentTypeCombo()
    if (!this.prepaymentModel.payment_type_id) this.prepaymentModel.payment_type_id = this.paymentTypesCombo[0]
  }

  onlyDecimalNumbers(evt: KeyboardEvent) {
    isDecimalNumber(evt);
  }

  formatAmount(amount: number) {
    return formatAmount(Number(amount) || 0);
  }

  hideModal() {
    commonModule.hideModal();
  }

  async doRecordPrepayment() {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      this.loading = true

      try {
        const { created_at_date, created_at_time, payment_type_id, ...rest } = this.prepaymentModel;

        const data = {
          ...rest,
          payment_type_id: payment_type_id.id,
          created_at: dayjs(`${created_at_date} ${created_at_time}`).toISOString(),
        };

        await clientsModule.createCreditDeposit({ clientId: this.payload.clientId, data });
        this.hideModal()
      } finally {
        this.loading = false;
      }
    }
  }

}
